import { ProductIndexItemInterface } from "../../../common/interfaces/apiV2/shared/ProductIndexItemInterface";
import { ProductGridItem } from "@hatch-digital-nl/bravilor-storybook";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useNavigate } from "react-router-dom";
import {
    convertProductToGridFormat,
    SimpleProduct,
} from "../../../common/utils/productConverters";
import { RouteEnum } from "../../../common/enums/RouteEnum";
import { selectProduct } from "../../../pages/productRangePage/ProductRangeSlice";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { StorybookSimpleProduct } from "../../../common/types/storybook";
import { JSX } from "react";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";

interface Props {
    category: string;
    resultCount: number;
    products: ProductIndexItemInterface[];
    isOldModel?: boolean;
}

export const ResultCategory = (props: Props): JSX.Element => {
    const { category, resultCount, products, isOldModel = false } = props;
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const userData = useGetUserInfoQuery();
    const { activeLanguage } = userData?.data || { activeLanguage: null };
    const { t, translations } = useStringTranslation();

    const { selectedProducts } = useAppSelector((state) => state.productRange);

    const handleProductSelect = (product: SimpleProduct): void => {
        dispatch(
            selectProduct(product.originalProduct as ProductIndexItemInterface),
        );
    };

    const handleProductClick = (product: SimpleProduct): void => {
        navigate(RouteEnum.PRODUCT_RANGE + `/${product.originalProduct.id}`);
    };

    return (
        <div className="c-result-category">
            <div className="c-result-category__header">
                <div className="c-result-category__header__title">
                    <span>{category}</span>
                </div>
                <div className="c-result-category__header__amount">
                    {resultCount}
                </div>
            </div>

            {products.length > 0 && (
                <div className="c-result-category__container">
                    {products.map((product) => {
                        const isSelected: boolean = selectedProducts.some(
                            (selectedProduct: ProductIndexItemInterface) =>
                                selectedProduct.id === product.id,
                        );
                        const gridProduct: SimpleProduct = {
                            ...convertProductToGridFormat(
                                product,
                                activeLanguage,
                                translations,
                            ),
                            isArchived: isOldModel,
                        };

                        return (
                            <ProductGridItem
                                key={"grid-" + product.id}
                                product={
                                    gridProduct as unknown as StorybookSimpleProduct
                                }
                                isSelected={isSelected}
                                viewProductText={t("view-product")}
                                oldModelText={t("old-models")}
                                disableCheckbox={false}
                                onProductSelect={(
                                    selectedProduct: StorybookSimpleProduct,
                                ) =>
                                    handleProductSelect(
                                        selectedProduct as unknown as SimpleProduct,
                                    )
                                }
                                onProductClick={(
                                    selectedProduct: StorybookSimpleProduct,
                                ) =>
                                    handleProductClick(
                                        selectedProduct as unknown as SimpleProduct,
                                    )
                                }
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};
